import React from 'react';

import { useSettings } from 'app/main/components';
import { ViewTable } from 'app/main/components/page-layouts';
import { type ViewPageContentTabProps } from 'app/main/components/page-layouts/view/ViewPage';

import getKpisGoalsTableColumns from '../KpisGoalsTableColumns';

export default function KpisGoalsTableTab(props: ViewPageContentTabProps) {
	const { settings, t } = useSettings('sys_kpis_goals');

	const columns = getKpisGoalsTableColumns({ settings, t, updateRefresh: props.updateRefresh });

	return (
		<ViewTable
			id="kpiGoalsView"
			module="sys_kpis_goals"
			columns={columns}
			refresh={props.refresh}
			updateRefresh={props.updateRefresh}
			defaultFilters={[{ filt_field: 'kpis_disabled', filt_clause: 'not_equal', filt_value: 1 }]}
		/>
	);
}
